// @flow
import React, { useState, useMemo, useEffect } from "react";
import { Button } from "@material-ui/core";
import InputField from "../../../components/ui/inputField";
import ValidatedDatePicker from "../../../components/ui/DatePicker";
import axios from "../../../axios-order";

import style from "../BusinessEntityDetails.module.css";
import NumberFormat from "react-number-format";
import { ValidatorForm } from "react-material-ui-form-validator";
import { toast } from "react-toastify";

import Radio from "@mui/material/Radio";
import RadioGroup from "@mui/material/RadioGroup";
import FormControlLabel from "@mui/material/FormControlLabel";
import FormControl from "@mui/material/FormControl";
import MenuItem from "@mui/material/MenuItem";
import Select from "@mui/material/Select";

export default function Edit(props) {
  const { cancelEditForm, editFormData, updateGetApi } = props;
  const [editTdsData, setEditTdsData] = useState({});
  
  // --- New State for Dependent Dropdown ---
  const [sectionMapping, setSectionMapping] = useState([]);
  const [sectionNewOptions, setSectionNewOptions] = useState([]);

  useEffect(() => {
    fetchSectionDropdown();
  }, []);

  const fetchSectionDropdown = () => {
    axios
      .get("/get_tds_section_dropdown")
      .then((res) => {
        const apiData = res.data.record || res.data;
        setSectionMapping(apiData);
        
        // If we already have a section in edit mode, populate the sub-options immediately
        if (editFormData.tds_section_as_per_certificate) {
            const matched = apiData.find(
                (item) => (item.section || item.code || item) === editFormData.tds_section_as_per_certificate
            );
            if (matched && matched.section_new) {
                setSectionNewOptions(matched.section_new);
            }
        }
      })
      .catch((err) => {
        console.error("Error fetching section dropdown:", err);
      });
  };

  useMemo(() => {
    setEditTdsData(editFormData);
  }, [editFormData]);

  const editInputChangeHandler = (e) => {
    let name = e.target.name;
    let value = e.target.value;
    setEditTdsData({
      ...editTdsData,
      [name]: value,
    });
  };

  const handleFromDateChange = (v) => {
    if (v != "Invalid Date" && v != null) {
      const pad = "00";
      const yy = v.getFullYear().toString();
      const mm = (v.getMonth() + 1).toString();
      const dd = v.getDate().toString();
      setEditTdsData({
        ...editTdsData,
        valid_from_date: `${yy}-${(pad + mm).slice(-2)}-${(pad + dd).slice(-2)}`,
      });
    }
  };

  const handleToDateChange = (v) => {
    if (v != "Invalid Date" && v != null) {
      const pad = "00";
      const yy = v.getFullYear().toString();
      const mm = (v.getMonth() + 1).toString();
      const dd = v.getDate().toString();
      setEditTdsData({
        ...editTdsData,
        valid_to_date: `${yy}-${(pad + mm).slice(-2)}-${(pad + dd).slice(-2)}`,
      });
    }
  };

  const finalEditData = {
    org_gstin: `${localStorage.getItem("gst")}`,
    records: [editTdsData],
  };

  const editFormsubmitHandler = (e) => {
    axios
      .put("/tds/ltds/edit", finalEditData)
      .then((res) => {
        if (res.data.status === true) {
          cancelEditForm();
          updateGetApi();
          toast.success(res.data.message, { autoClose: 2000 });
        } else {
          toast.error(res.data.message, { autoClose: 2000 });
        }
      })
      .catch((err) => {
        console.log(err);
      });
  };

  return (
    <ValidatorForm
      onSubmit={editFormsubmitHandler}
      onError={(errors) => console.log(errors)}
    >
      <FormControl>
        <label style={{ margin: "0px" }}>TDS Type</label>
        <RadioGroup
          row
          name="TDSType"
          value={editTdsData.TDSType ?? ""}
          onChange={editInputChangeHandler}
        >
          <FormControlLabel value="Sales" control={<Radio disabled />} label="Sales" />
          <FormControlLabel value="Purchase" control={<Radio disabled />} label="Purchase" />
          <FormControlLabel value="NRI" control={<Radio disabled />} label="NRI" />
        </RadioGroup>
      </FormControl>

      <InputField
        textLabel={editTdsData.TDSType === "NRI" ? "Vendor Name" : "Legal Name"}
        inputType="text"
        inputProps={{ maxLength: 100 }}
        name="vendor_legal_name"
        value={editTdsData.vendor_legal_name ?? ""}
        requiredField="*"
        validator={["required"]}
        errorMsg={["This field is required"]}
        textOnchangeFunction={editInputChangeHandler}
      />

      <InputField
        textLabel="PAN"
        inputType="text"
        name="pan"
        value={editTdsData.pan ?? ""}
        requiredField="*"
        validator={["required"]}
        errorMsg={["This field is required"]}
        textOnchangeFunction={editInputChangeHandler}
        inputProps={{ readOnly: true }}
      />

      <div style={{ marginTop: "20px" }}>
        <label>From Date <span style={{ color: "red" }}>*</span>:</label>
        <ValidatedDatePicker
          name="valid_from_date"
          value={editTdsData.valid_from_date ?? ""}
          onChange={(v) => handleFromDateChange(v)}
          validators={["required"]}
          errorMessages={["This field is required"]}
          disabled={true}
        />
      </div>

      <div style={{ marginTop: "20px" }}>
        <label>To Date <span style={{ color: "red" }}>*</span>:</label>
        <ValidatedDatePicker
          name="to_date"
          value={editTdsData.valid_to_date ?? ""}
          onChange={(v) => handleToDateChange(v)}
          validators={["required"]}
          errorMessages={["This field is required"]}
          disabled={true}
        />
      </div>

      <InputField
        textLabel="Certificate no for ltds"
        inputType="text"
        inputProps={{ maxLength: 10 }} 
        name="certificate_no_for_ltds"
        value={editTdsData.certificate_no_for_ltds ?? ""}
        requiredField="*"
        validator={["required"]}
        errorMsg={["This field is required"]}
        textOnchangeFunction={editInputChangeHandler}
      />

      <InputField
        textLabel="Section as per certificate"
        inputType="text"
        name="tds_section_as_per_certificate"
        value={editTdsData.tds_section_as_per_certificate ?? ""}
        requiredField="*"
        inputProps={{ readOnly: true }} 
        validator={["required"]}
        errorMsg={["This field is required"]}
        textOnchangeFunction={editInputChangeHandler}
        disabled={true}
      />

      {/* NEW COLUMN: Section New */}
      <div style={{ marginTop: "20px" }}>
        <label>Section New <span style={{ color: "red" }}>*</span>:</label>
        <FormControl fullWidth style={{ marginTop: "8px" }}>
          <Select
            name="section_new"
            value={editTdsData.section_new ?? ""}
            onChange={editInputChangeHandler}
            style={{ height: "40px" }}
            displayEmpty
          >
            {sectionNewOptions.length > 0 ? (
                sectionNewOptions.map((item, index) => (
                    <MenuItem key={index} value={item}>{item}</MenuItem>
                ))
            ) : (
                <MenuItem disabled value="">No Sub-sections available</MenuItem>
            )}
          </Select>
        </FormControl>
      </div>

      <InputField
        textLabel="Tds as per certificate"
        inputType="text"
        name="tds_as_per_certificate"
        inputProps={{ maxLength: 10 }} 
        value={editTdsData.tds_as_per_certificate ?? ""}
        validator={[
          "matchRegexp:^([0]|[1-9][0-9]?|100)$|^[0-9]{0,2}.[0-9]{1,2}$",
          "maxFloat:100.00",
        ]}
        errorMsg={["invalid percentage.", "invalid percentage."]}
        textOnchangeFunction={editInputChangeHandler}
      />

      <div style={{ marginTop: "20px" }}>
        <label>₹ Limit amount:</label> <br />
        <NumberFormat
          className={style.numberFormate}
          style={{ paddingLeft: "10.5px" }}
          value={editTdsData.limit_amount ? editTdsData.limit_amount : ""}
          thousandsGroupStyle="lakh"
          prefix="₹"
          required
          decimalSeparator="."
          displayType="number"
          type="text"
          decimalScale={2}
          thousandSeparator={true}
          allowNegative={true}
          onValueChange={(values) => {
            const { value } = values;
            setEditTdsData({
              ...editTdsData,
              limit_amount: value === "" ? 0 : parseFloat(value),
            });
          }}
        />
      </div>

      <div className="mt-20">
        <button className="button-primary" type="submit">Submit</button>
        <button className="button-outlined-secondary" type="button" onClick={cancelEditForm}>cancel</button>
      </div>
    </ValidatorForm>
  );
}